var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9146 11.5303C14.1271 9.31018 14.1271 5.69339 11.9146 3.47322L10.7343 4.65351V1.09745H14.2903L12.9165 2.47129C15.6946 5.24556 15.6946 9.75801 12.9165 12.5361C11.1631 14.2856 8.72284 14.9346 6.46092 14.4716V13.0067C8.34712 13.4962 10.4383 13.0067 11.9146 11.5303Z",
    fill: "#2999BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85172 2.47129C4.60508 0.714134 7.04537 0.0651611 9.30729 0.528171V1.9931C7.4211 1.50353 5.32617 2.00069 3.85364 3.47322C1.63347 5.69339 1.63347 9.31018 3.85364 11.5303L5.03394 10.3501V13.9099H1.47408L2.84792 12.5361C0.0736603 9.75801 0.0736595 5.24556 2.85172 2.47129Z",
    fill: "#2999BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/ReloadIcon.dcac28b3d2c2166716890e63aaf48216.svg";
export { ForwardRef as ReactComponent };